// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import Rails from '@rails/ujs'
import * as ActiveStorage from '@rails/activestorage'
import 'channels'

import { mountComponents } from 'mount-react-components'

import 'bootstrap'
import 'cocoon-js'
import 'select2'

import BrewActivityForm from './BrewActivityForm'
import Chart from 'react-apexcharts'
import ClientsMap from './ClientsMap'

require('@popperjs/core')

require('stylesheets/application.scss')

require.context('images', true)

Rails.start()
ActiveStorage.start()

mountComponents({
  BrewActivityForm,
  Chart,
  ClientsMap
})

document.addEventListener('DOMContentLoaded', () => {
  $('.select2').select2({ theme: 'bootstrap4' })
})
